import React, { useState } from 'react'
import Link from 'next/link'
import { storyDetailEvents } from 'lib/ga'

const StoryTags = ({ tags, displayCount = 1 }) => {
  const [open, setOpen] = useState(false)
  if (!tags.length) return null
  let _tags = open ? tags : tags.slice(0, displayCount)
  return (
    <>
      <div className='storyTags'>
        {_tags.map((tag, idx) => (
          <Link key={idx} href='/topics/[slug]' as={`/topics/${tag.replace(/\W+/g, '-').toLowerCase()}`}>
            <a
              className='storyTag'
              onClick={() => {
                storyDetailEvents.clickTag(tag)
              }}
            >
              {tag.replace(/-/g, ' ')}
            </a>
          </Link>
        ))}
        {!open && tags.length > displayCount ? (
          <a className='storyTag storyTag--toggle' onClick={setOpen}>
            + {tags.length - displayCount} Tags
          </a>
        ) : null}
      </div>
      <style jsx>{`
        .storyTags {
          margin-top: 25px;
        }
        .storyTag {
          display: inline-block;
          color: #999;
          font-size: 10px;
          font-weight: bold;
          letter-spacing: 0.58px;
          text-transform: uppercase;
          background: #f1f1f1;
          padding: 8px 16px;
          margin: 0 8px 8px 0;
          border-radius: 20px;
        }
        .storyTag--toggle {
          cursor: pointer;
          background: transparent;
          padding-left: 0;
        }
      `}</style>
    </>
  )
}

export default StoryTags
